import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=091aea70&scoped=true&"
import script from "./OrganisationList.vue?vue&type=script&lang=ts&"
export * from "./OrganisationList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&id=091aea70&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091aea70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091aea70')) {
      api.createRecord('091aea70', component.options)
    } else {
      api.reload('091aea70', component.options)
    }
    module.hot.accept("./OrganisationList.vue?vue&type=template&id=091aea70&scoped=true&", function () {
      api.rerender('091aea70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationList.vue"
export default component.exports